import 'svelte/internal/disclose-version';

Rail[$.FILENAME] = 'src/components/Rail.svelte';

import * as $ from 'svelte/internal/client';
import RestaurantCard from "./RestaurantCard.svelte";

var root = $.add_locations($.from_html(`<p class="svelte-1b3y2z4"> </p>`), Rail[$.FILENAME], [[17, 22]]);
var root_1 = $.add_locations($.from_html(`<a class="more svelte-1b3y2z4"> </a>`), Rail[$.FILENAME], [[20, 22]]);
var root_2 = $.add_locations($.from_html(`<div class="item svelte-1b3y2z4"><!></div>`), Rail[$.FILENAME], [[28, 8]]);

var root_3 = $.add_locations($.from_html(`<section class="rail svelte-1b3y2z4"><div class="head svelte-1b3y2z4"><div><h2 class="svelte-1b3y2z4"> </h2> <!></div> <div class="controls svelte-1b3y2z4"><!> <button type="button" aria-label="Scroll left" class="svelte-1b3y2z4">‹</button> <button type="button" aria-label="Scroll right" class="svelte-1b3y2z4">›</button></div></div> <div class="scroller svelte-1b3y2z4"></div></section>`), Rail[$.FILENAME], [
	[
		13,
		2,
		[
			[14, 4, [[15, 6, [[16, 8]]], [19, 6, [[21, 8], [22, 8]]]]],
			[26, 4]
		]
	]
]);

const $$css = {
	hash: 'svelte-1b3y2z4',
	code: '\n  .rail.svelte-1b3y2z4 { margin: 0 0 40px; }\n  .head.svelte-1b3y2z4 {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 14px;\n  }\n  h2.svelte-1b3y2z4 { font-size: 1.32rem; }\n  p.svelte-1b3y2z4 { margin: 3px 0 0; color: var(--ink-soft); font-size: 0.88rem; }\n\n  .controls.svelte-1b3y2z4 { display: flex; align-items: center; gap: 6px; flex: none; }\n  .more.svelte-1b3y2z4 { font-size: 0.86rem; font-weight: 600; color: var(--accent); margin-right: 4px; }\n  .more.svelte-1b3y2z4:hover { text-decoration: underline; }\n  .controls.svelte-1b3y2z4 button:where(.svelte-1b3y2z4) {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: 1px solid var(--line-strong);\n    background: var(--card);\n    cursor: pointer;\n    font-size: 1.2rem;\n    line-height: 1;\n    color: var(--ink-soft);\n  }\n  .controls.svelte-1b3y2z4 button:where(.svelte-1b3y2z4):hover { background: var(--accent-soft); color: var(--ink); }\n\n  .scroller.svelte-1b3y2z4 {\n    display: flex;\n    gap: 16px;\n    overflow-x: auto;\n    scroll-snap-type: x proximity;\n    padding-bottom: 6px;\n    scrollbar-width: thin;\n  }\n  .item.svelte-1b3y2z4 { flex: 0 0 250px; scroll-snap-align: start; }\n\n  @media (max-width: 620px) {\n    .item.svelte-1b3y2z4 { flex-basis: 78vw; }\n    .controls.svelte-1b3y2z4 button:where(.svelte-1b3y2z4) { display: none; }\n  }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function Rail($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Rail);
	$.append_styles($$anchor, $$css);

	let subtitle = $.prop($$props, 'subtitle', 3, ""),
		items = $.prop($$props, 'items', 19, () => []),
		moreHref = $.prop($$props, 'moreHref', 3, null),
		moreLabel = $.prop($$props, 'moreLabel', 3, "See all");

	let scroller;

	function scrollBy(direction) {
		scroller?.scrollBy({
			left: direction * Math.max(280, scroller.clientWidth * 0.8),
			behavior: "smooth"
		});
	}

	var $$exports = { ...$.legacy_api() };
	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_2 = ($$anchor) => {
			var section = root_3();
			var div = $.child(section);
			var div_1 = $.child(div);
			var h2 = $.child(div_1);
			var text = $.child(h2, true);

			$.reset(h2);

			var node_1 = $.sibling(h2, 2);

			{
				var consequent = ($$anchor) => {
					var p = root();
					var text_1 = $.child(p, true);

					$.reset(p);
					$.template_effect(() => $.set_text(text_1, subtitle()));
					$.append($$anchor, p);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if (subtitle()) $$render(consequent);
					}),
					'if',
					Rail,
					17,
					8
				);
			}

			$.reset(div_1);

			var div_2 = $.sibling(div_1, 2);
			var node_2 = $.child(div_2);

			{
				var consequent_1 = ($$anchor) => {
					var a = root_1();
					var text_2 = $.child(a, true);

					$.reset(a);

					$.template_effect(() => {
						$.set_attribute(a, 'href', moreHref());
						$.set_text(text_2, moreLabel());
					});

					$.append($$anchor, a);
				};

				$.add_svelte_meta(
					() => $.if(node_2, ($$render) => {
						if (moreHref()) $$render(consequent_1);
					}),
					'if',
					Rail,
					20,
					8
				);
			}

			var button = $.sibling(node_2, 2);
			var button_1 = $.sibling(button, 2);

			$.reset(div_2);
			$.reset(div);

			var div_3 = $.sibling(div, 2);

			$.add_svelte_meta(
				() => $.each(div_3, 21, items, (restaurant) => restaurant.id, ($$anchor, restaurant) => {
					var div_4 = root_2();
					var node_3 = $.child(div_4);

					$.add_svelte_meta(
						() => RestaurantCard(node_3, {
							get restaurant() {
								return $.get(restaurant);
							},
							compact: true
						}),
						'component',
						Rail,
						28,
						26,
						{ componentTag: 'RestaurantCard' }
					);

					$.reset(div_4);
					$.append($$anchor, div_4);
				}),
				'each',
				Rail,
				27,
				6
			);

			$.reset(div_3);
			$.bind_this(div_3, ($$value) => scroller = $$value, () => scroller);
			$.reset(section);
			$.template_effect(() => $.set_text(text, $$props.title));

			$.delegated('click', button, function click() {
				return scrollBy(-1);
			});

			$.delegated('click', button_1, function click_1() {
				return scrollBy(1);
			});

			$.append($$anchor, section);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (items().length > 0) $$render(consequent_2);
			}),
			'if',
			Rail,
			12,
			0
		);
	}

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click']);